//get delAddress
'use client';
import React, { useEffect, useState, useRef } from 'react';
import {
  setOptimoData,
  setDeliveryData,
  setBillingData,
  resetDeliveryData,
} from '@/app/redux/slices/configBasketSlice.js';
import {
  setDelAddError,
  setBillAddError,
} from '@/app/redux/slices/configSiteSlice';
import { useSelector, useDispatch } from 'react-redux';
import '@/app/(contentPages)/(checkout)/summary/summary.css';
import { Box, Button } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-solid-svg-icons';
import { setStateValue } from '@/app/redux/slices/configGymSlice';
import getNearestLocation from '@/app/functions/getNearestLocation';

function AddressAutocomplete({ addressType, onAddressUpdate }) {
  const billSame = useSelector((state) => state.site.BillAddSame);
  const optimoId = useSelector((state) => state.basket.basketData.basketID);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState('');
  const [formatAddressBlock, setFormatAddressBlock] = useState([]);
  const [postcodeBlock, setPostcodeBlock] = useState([]);
  const apiKey = process.env.NEXT_PUBLIC_GETADDRESS_API_KEY;
  const deliveryData = useSelector((state) => state.basket.deliveryData);
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const postcodeDel = useSelector(
    (state) => state.basket.deliveryData.postcode
  );
  const delData = useSelector((state) => state.basket.deliveryData);
  const deliveryOK = postcodeDel ? true : false;
  const service = useSelector((state) => state.gym.serviceOpt);
  const mirrorTotal = useSelector((state) => state.gym.mirrorTotal);
  const optimoDate = useSelector((state) => state.gym.optimoDate);
  const bespokeMirrorTotal = useSelector(
    (state) => state.gym.bespokeMirrorTotal
  );
  const mirrorQty = bespokeMirrorTotal + mirrorTotal;

  // Set time allocated
  const extraTime = (mirrorQty - 2) * 30;
  const reqTime = service !== 'survey' ? 60 + extraTime : 45;

  const SaveAddress = (addressData, addressType) => {
    // console.log('saving Address data');
    const addressText = addressData.formatted_address;
    const addressString = Array.isArray(addressText)
      ? addressText.join(', ')
      : addressText;
    const nearest = getNearestLocation(
      addressData.latitude,
      addressData.longitude
    );
    //console.log('nearest Van Run ', nearest.vanRun);
    //console.log('nearest Location', nearest.location);
    const optimoData = {
      operation: 'CREATE',
      orderNo: optimoId,
      date: optimoDate,
      duration: reqTime,
      type: 'T',
      load1: mirrorQty,
      assignedTo: { serial: 'F-01' },
      location: {
        longitude: addressData.longitude,
        latitude: addressData.latitude,
        address: addressString,
        locationName: addressData.postcode || 'Unnamed Location', // Use postcode or fallback name
        locationNo: optimoId || 'new_location', // Use job number if available
        valid: true, // Boolean for validity
        notes: addressData.notes || 'No additional notes',
        checkInTime: 60, // in minutes
      },
      timeWindows: [
        {
          twFrom: '07:30',
          twTo: '18:00',
        },
      ],
      allowedWeekdays: ['mon', 'tue', 'wed', 'thu', 'fri'],
      allowedDates: {},
      allowedDateTimes: [],
      skills: [],
      vehicleFeatures: [],
      notes: '',
      email: '',
      phone: '',
      customField1: service,
      customField2: nearest.location,
      customField3: nearest.vanRun,
      customField4: '',
      customField5: '',
      notificationPreference: 'email',
    };
    dispatch(setOptimoData(optimoData));
    dispatch(setDeliveryData(addressData));

    if (billSame) {
      dispatch(setBillingData(addressData));
      dispatch(setBillAddError(true));
    }

    if ((addressType = 'survey')) {
      console.log('Add Address to Optimo:', optimoData);
    }
    if (onAddressUpdate) {
      onAddressUpdate(addressData);
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://cdn.getaddress.io/scripts/getaddress-autocomplete-1.1.3.min.js';
    script.async = true;
    script.onload = () => {
      const getAddress = window.getAddress;
      getAddress.autocomplete('address-input1', apiKey, {
        select_on_focus: true,
        id_prefix: 'getAddress-autocomplete',
      });
    };
    document.body.appendChild(script);

    const handleAddressSelected = (e) => {
      if (e.target.id.includes('input1')) {
        console.log('Process Delivery Data');
        let tobeformatted = e.address.formatted_address.toString();
        let formattedAddress = tobeformatted
          .replace(/,+/g, ', ')
          .replace(/,$/, '');
        setSelectedAddress(formattedAddress);
        setFormatAddressBlock(e.address.formatted_address);
        setPostcodeBlock(e.address.postcode);
        SaveAddress(e.address, addressType);
        dispatch(setDelAddError(true));
      }
    };

    document.addEventListener(
      'getaddress-autocomplete-address-selected',
      handleAddressSelected
    );

    return () => {
      // Cleanup: Remove event listener and script element
      document.removeEventListener(
        'getaddress-autocomplete-address-selected',
        handleAddressSelected
      );
      document.body.removeChild(script);
    };
  }, [deliveryOK]);

  // Set the input value to the selectedAddress
  const handleInputChange = (e) => {
    const cleanedValue = e.target.value.replace(/,+/g, ',');
    setSelectedAddress(e.target.value);
  };
  const handleChangeDelivery = () => {
    setSelectedAddress('');
    dispatch(resetDeliveryData());
    setFormatAddressBlock('');
    dispatch(setDelAddError(false));
    dispatch(setStateValue({ key: 'requestedSlotID', value: null }));
    dispatch(setStateValue({ key: 'nearest', value: null }));
  };
  const handleKeyDown = (e) => {
    // If the Tab key is pressed (key code 9), prevent its default behavior
    if (e.key === 'Tab' || e.key === 'Enter') {
      e.preventDefault();
    }
  };

  return (
    <>
      {!deliveryOK && (
        <Box
          borderWidth="1px"
          borderRadius={{ base: '6vw', md: '3vw' }}
          border="solid 1px #00000030"
          backgroundColor={'white'}
          p={{ base: '3vw 4vw', md: '0.8vw 1.5vw' }}
          cursor="text"
          _hover={{ borderColor: 'blue.300' }}
          _focus={{ borderColor: 'blue.500' }}
        >
          <input
            type="text"
            id="address-input1"
            style={{
              border: 'solid 0 white',
              outline: 'none',
              fontSize: { base: '4vw', md: '0.9vw' },
            }}
            value={selectedAddress}
            onChange={handleInputChange}
            placeholder="Start typing your address or postcode"
            onKeyDown={handleKeyDown}
            width="100%"
            ref={inputRef}
          />
        </Box>
      )}
      {deliveryOK && (
        <Box
          padding="1vw 0 1vw 2vw"
          fontWeight={600}
          color="#00000090"
          minHeight="8.5vw"
        >
          {deliveryData.formatted_address[0] && (
            <div>{deliveryData.formatted_address[0]}</div>
          )}
          {deliveryData.formatted_address[1] && (
            <div>{deliveryData.formatted_address[1]}</div>
          )}
          {deliveryData.formatted_address[2] && (
            <div>{deliveryData.formatted_address[2]}</div>
          )}
          {deliveryData.formatted_address[3] && (
            <div>{deliveryData.formatted_address[3]}</div>
          )}
          {deliveryData.formatted_address[4] && (
            <div>{deliveryData.formatted_address[4]}</div>
          )}
          {postcodeBlock && (
            <div style={{ marginRight: 'auto' }}>{deliveryData.postcode}</div>
          )}
        </Box>
      )}
      {deliveryOK && (
        <Box
          paddingLeft="2vw"
          width={{ base: '100%', md: '' }}
          margin={{ base: '4vw 0', md: '0' }}
        >
          <Button
            className="dkButtonRoundedSlim"
            columnGap="1vw"
            onClick={handleChangeDelivery}
          >
            <FontAwesomeIcon icon={faPen} width="20px" />
            Change Address
          </Button>
        </Box>
      )}
    </>
  );
}

export default AddressAutocomplete;
